export const TILE_WIDTH = 60
export const GAP_BETWEEN_TILES = 2
export const HERO_WIDTH = TILE_WIDTH - 8
export const LIGHT_SPOT_SIZE = HERO_WIDTH
